import React, { useState, useEffect, useContext } from 'react';
import { Route, useLocation, useParams, useHistory } from 'react-router-dom';
import Tabs from './Tabs';
import Tab from './Tab';
var TabsContext = React.createContext({});
export var useTabsNavigation = function (_a) {
    var mainPath = _a.mainPath, _b = _a.tabs, tabs = _b === void 0 ? [] : _b;
    var history = useHistory();
    var location = useLocation();
    var params = useParams();
    var _c = useState(''), value = _c[0], setValue = _c[1];
    var onChange = function (target) {
        var id = params.id;
        var pathname = location.pathname;
        if (target === 'newChild') {
            return history.push(pathname + "/new-child");
        }
        return history.push("/" + mainPath + "/" + id + "/" + target);
    };
    var toNewChild = function () { return onChange('newChild'); };
    var toEditChild = function (item) { return history.push(location.pathname + "/" + item.id); };
    var toViewChild = function (item) {
        return history.push(location.pathname + "/" + item.id + "?mode=view");
    };
    useEffect(function () {
        tabs.forEach(function (tab) {
            if (tab.value === undefined) {
                // eslint-disable-next-line no-console
                console.error('Tab must have a value property');
            }
        });
        var pathname = location.pathname;
        var _a = tabs
            .map(function (tabItem) { return (pathname.includes(tabItem.value) ? tabItem.value : ''); })
            .filter(function (x) { return !!x; })[0], tab = _a === void 0 ? '' : _a;
        return setValue(tab);
    }, [location.pathname, location, tabs]);
    return {
        value: value,
        onChange: onChange,
        toEditChild: toEditChild,
        toViewChild: toViewChild,
        toNewChild: toNewChild,
        mainPath: mainPath,
        tabs: tabs,
    };
};
export var makePath = function (_a) {
    var mainPath = _a.mainPath, name = _a.name, isForm = _a.isForm;
    if (!name)
        return "/" + mainPath + "/:id";
    if (isForm)
        return "/" + mainPath + "/:id/" + name + "/:childId";
    return "/" + mainPath + "/:id/" + name;
};
export var CrudRoute = function (_a) {
    var _b = _a.name, name = _b === void 0 ? '' : _b, isForm = _a.isForm, render = _a.render, component = _a.component;
    var tabsContext = useContext(TabsContext);
    return (React.createElement(Route, { path: makePath({
            mainPath: tabsContext.mainPath,
            name: name,
            isForm: isForm,
        }), exact: true, component: component, render: render }));
};
export var CrudTabs = function (_a) {
    var value = _a.value, mainPath = _a.mainPath, children = _a.children, onChange = _a.onChange, tabs = _a.tabs, disabled = _a.disabled;
    var location = useLocation();
    return (React.createElement(React.Fragment, null,
        React.createElement(Tabs, { indicatorColor: "primary", value: value, onChange: function (_, v) { return onChange(v); } }, tabs.map(function (tab, index) { return (React.createElement(Tab, { key: tab.value, value: tab.value, disabled: (index > 0 && location.pathname.includes('new')) || disabled && disabled(tab), label: tab.label })); })),
        React.createElement(TabsContext.Provider, { value: { mainPath: mainPath } }, children)));
};
CrudRoute.defaultProps = {
    isForm: false,
    name: '',
};
CrudTabs.defaultProps = {
    tabs: [],
};
//# sourceMappingURL=CrudTabs.js.map